import script from "./craeteStaff.vue?vue&type=script&setup=true&lang=js"
export * from "./craeteStaff.vue?vue&type=script&setup=true&lang=js"

import "./craeteStaff.vue?vue&type=style&index=0&id=86cc7496&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86cc7496"]])

export default __exports__